import getAssetUrl from 'utils/getAssetUrl';
import { Col, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/generalUI/Button';
import styles from './Header.module.scss';

const Header = () => {
  const { t } = useTranslation();

  return (
    <Row className={styles.Container}>
      <Col className={styles.MainTextContainer} xs={24} sm={8}>
        <h3 className={styles.UpperText}>{t('pages.corporateEvents.companies')}</h3>
        <h1 className={styles.Title}>{t('pages.corporateEvents.corporateEvents')}</h1>
        <p className={styles.Description}>{t('pages.corporateEvents.description')}</p>
        <Button className={styles.QuoteButton}>
          <a href="#quote-corporate-event">{t('pages.corporateEvents.quote')}</a>
        </Button>
      </Col>
      <Col className={styles.MainImageContainer} xs={24} sm={16}>
        <img
          className={styles.MainImage}
          src={getAssetUrl('/assets/carousel/FOTO_5.jpg')}
          alt="Corporate events"
        />
      </Col>
    </Row>
  );
};

export default Header;
